import PrivateRoute from "@/router/PrivateRoot";
import StudentDashboardPage from "@/pages/student/dashboard/studentDashboardPage";
import StudentBillingPage from "@/pages/student/billing/studentBillingPage";
import StudentProfilePage from "@/pages/student/profile/studentProfilePage";
import FirstCompleteProfilePage from "@/pages/student/first/firstCompleteProfilePage";
import StudentCertificationListPage from "@/pages/student/certifications/studentCertificationListPage";
import StudentSurveyCertificatePage from "@/pages/student/survey/studentSurveyCertificatePage";
import StudentLessonTakePage from "@/pages/student/lessons/take/StudentLessonListPage";
import StudentLessonDetailPage from "@/pages/student/lessons/take/[id]/StudentLessonDetailPage";
import StudentMyLessonListPage from "@/pages/student/lessons/myLesson/StudentMyLessonListPage";
import StudentShowMyLessonPage from "@/pages/student/lessons/myLesson/[id]/StudentShowMyLessonPage";
import NotificationsPage from "@/pages/notification/notificationsPage";
import ChooseGradePage from "@/pages/student/lessons/steps/ChooseGradePage";
import StudentLessonExamPage from "@/pages/student/lessons/exam/[id]/StudentLessonExamPage";
import StudentInstallmentListPage from "@/pages/student/installments/StudentInstallmentListPage";
import ErrorPage from "@/components/error/ErrorPage";
import StudentScoresPage from "@/pages/student/scores/studentScoresPage";
import StudentHomeworkDetail from "@/pages/student/lessons/myLesson/[id]/homework/[id]/StudentHomeworkDetail";
import StudentAbsencesPage from "@/pages/student/absences/studentAbsencesPage";
import StudentLessonMapPage from "@/pages/student/lessons/take/StudentLessonMapPage";
import StudentPublicSurveyList from "@/pages/student/survey/list/StudentPublicSurveyList";
import StudentLoadPublicSurvey from "@/pages/student/survey/list/[id]/StudentLoadPublicSurvey";
import {Outlet} from "react-router-dom";
import StudentRefundPage from "@/pages/student/billing/refund/StudentRefundPage";

export const StudentRoute = [
    {
        path: '/student',
        element: <PrivateRoute module={'student'}/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <StudentDashboardPage/>,
            },
            {
                path: 'notifications',
                element: <NotificationsPage module={'student'}/>,
            },
            /**
             * --------------- Billing ---------------
             */
            {
                path: 'billing',
                element: <Outlet/>,
                children: [
                    {
                        index: true,
                        element: <StudentBillingPage/>,
                    },
                    {
                        path: 'refund',
                        element: <StudentRefundPage/>,
                    }
                ]
            },

            {
                path: 'installments',
                element: <StudentInstallmentListPage/>,
            },

            /**
             * --------------- Profile ---------------
             */
            {
                path: 'profile',
                element: <StudentProfilePage/>,
            },
            {
                path: 'first',
                element: <FirstCompleteProfilePage/>,
            },

            /**
             * --------------- Certification ---------------
             */
            {
                path: 'certifications',
                element: <StudentCertificationListPage/>,
            },
            {
                path: 'survey/certificate/:id',
                element: <StudentSurveyCertificatePage/>,
            },
            {
                path: 'survey/list',
                element: <StudentPublicSurveyList/>,
            },

            {
                path: 'survey/list/:id',
                element: <StudentLoadPublicSurvey/>,
            },


            /**
             * --------------- Lessons ---------------
             */
            {
                path: 'lessons/take',
                element: <StudentLessonTakePage/>,
            },
            {
                path: 'lessons/map',
                element: <StudentLessonMapPage/>,
            },
            {
                path: 'lessons/take-grade',
                element: <ChooseGradePage/>,
            },
            {
                path: 'lessons/take/:id',
                element: <StudentLessonDetailPage/>,
            },
            {
                path: 'lessons/exam/:id',
                element: <StudentLessonExamPage/>,
            },
            {
                path: 'lessons/my-lesson',
                element: <StudentMyLessonListPage/>,
            },
            {
                path: 'lessons/my-lesson/:id',
                element: <StudentShowMyLessonPage/>,
            },
            {
                path: 'lessons/my-lesson/:id/homework/:homeworkId',
                element: <StudentHomeworkDetail/>,
            },

            /**
             * --------------- Scores ---------------
             */
            {
                path: 'scores',
                element: <StudentScoresPage/>,
            },

            /**
             * --------------- Absences ---------------
             */
            {
                path: 'absences',
                element: <StudentAbsencesPage/>,
            }
        ],
    },
]